import { NgModule } from '@angular/core';

import { AwsModule } from '../aws/aws.module';
import { UtilModule } from '../util/util.module';
import { BillingService } from './billing.service';

@NgModule({
    imports: [
        UtilModule,
        AwsModule
    ],
    declarations: [],
    providers: [
        BillingService
    ],
    exports: []
})
export class BillingModule { }



// WEBPACK FOOTER //
// ./src/app/billing/billing.module.ts